import React, { Component } from 'react';
import {connect} from 'react-redux';
import { translate } from 'react-i18next';
import history from '../../../other/history';
import cx from '../../../styles';
import {Icon} from '../../../components/Common/Icon';
import {mobileCheck, gtmSend} from '../../../helpers';

class SearchBarContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {searchedTerm: ''};
    }

    componentDidMount() {
        if(history.location.pathname === '/search') {
            this.setState({searchedTerm: this.props.searchReducer.q});
        }
        //auto focus for mobile
        if(mobileCheck() && this.props.match.url === '/search') {
            this.searchInputFocus();
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.searchReducer.q !== this.props.searchReducer.q) {
            this.setState({searchedTerm: nextProps.searchReducer.q});
        }
    }

    onSearchTermChange = (e) => {
        this.setState({searchedTerm: e.target.value});
    }

    onSubmit = (e) => {
        e.preventDefault();
        if(!this.state.searchedTerm) return false;
        // history.push({pathname: '/search', search: `?q=${this.state.searchedTerm}`});
        window.location.replace(`/search?q=${this.state.searchedTerm}&tab=top`);
        gtmSend('cw_search_request', 'Search', 'Search Request', `${this.state.searchedTerm}`, 0)
        this.searchInputBlur();
    }

    searchInputBlur = () => {
        this.refs.searchInput.blur();
    }

    searchInputFocus = () => {
        this.refs.searchInput.focus();
    }

    render(){
        const {t, isFullWidth} = this.props;

        return (
            <div className={cx("search-bar-container")}>
                <form className={cx(isFullWidth ? "full-width-box" : "")} onSubmit={this.onSubmit}>
                    <input 
                        className={cx("search-box")} 
                        placeholder={isFullWidth ? t('search_placeholder') : t('search_placeholder_simple')} 
                        type="text"
                        title="query" name="query" 
                        value={decodeURIComponent(this.state.searchedTerm)} 
                        onChange={this.onSearchTermChange} 
                        ref="searchInput" 
                        onClick={()=>gtmSend('cw_search_click', 'Search', 'Search Bar Click', `${window.location}`, 0)}
                    />

                    <span className={cx('pointer-click')} onClick={this.onSubmit}><Icon name="search-regular-gray-md" /></span>
                </form>
            </div>
        );
    }
}

//map state
const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(translate()(SearchBarContainer));
